import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './staff.component.html',
    standalone: false
})
export class InstallationStaffPluginComponent {
  public staff: any[];
  public config: any;
  public editRoute = ['installation', 'staff', 'edit'];

  constructor(private cdRef: ChangeDetectorRef, private translateService: TranslateService) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  hasValue(item) {
    return (
      item?.BobstBSF === true ||
      item?.BobstBCC === true ||
      item?.BobstAgent === true ||
      item?.Customer === true ||
      item?.ThirdParty === true ||
      item?.NA === true
    );
  }

  getProvenanceText(item) {
    const provenances = [];

    if (item?.BobstBSF === true) provenances.push(this.translateService.instant('plugins.installationstaff.bobst-bsf'));
    if (item?.BobstBCC === true) provenances.push(this.translateService.instant('plugins.installationstaff.bobst-bcc'));
    if (item?.BobstAgent === true)
      provenances.push(this.translateService.instant('plugins.installationstaff.bobst-agent'));
    if (item?.Customer === true) provenances.push(this.translateService.instant('plugins.installationstaff.customer'));
    if (item?.ThirdParty === true)
      provenances.push(this.translateService.instant('plugins.installationstaff.third-party'));
    if (item?.NA === true) provenances.push(this.translateService.instant('plugins.installationstaff.non-applicable'));

    return provenances.join(', ');
  }

  private initData() {
    this.staff = this.config.Staff;
  }
}
PluginComponent.plugins['installationstaff'] = InstallationStaffPluginComponent;
